module.exports = __webpack_public_path__ + "img/network.88739e8a.png";